import React from "react";
import { Grid, Divider } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
} from "App/Component/ui";
import { TYPE_INSTANCE4 } from "App/constants";
import { useSelectOption } from "App/hooks";
import { RESET_STATE_FORM_FILTER } from "./helpers";
// import { accessCode } from "utils/all";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import DatePicker from "react-datepicker";
import moment from "moment";

export default function FormFilterDaftarAdjusmentStock({
  formFilter,
  setFormFilter,
  setNewData,
}) {
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const gudangUtama = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterGudangLGS.get,
    TYPE_INSTANCE4,
    "gudangId",
    "name"
  );

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={6}>
            <InputTextMaster
              name='id'
              label='ID PEMAKAIAN'
              id='id'
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder='ID Pemakaian'
            />
          </Grid>
          <Grid item sm={6}>
            <InputOptionMaster
              name='gudang_id'
              label='GUDANG UTAMA LOGISTIK'
              id='gudang_id'
              withSearch={true}
              data={gudangUtama}
              value={formFilter.gudang_id}
              labelValue={formFilter.gudang}
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  gudang_id: e?.value,
                  gudang: e?.label,
                })
              }
            />
          </Grid>
          <Grid item sm={6}>
            <label htmlFor='date' className='form-control-label'>
              TANGGAL AWAL
            </label>

            <DatePicker
              id='date'
              autoComplete='off'
              className='form-control text'
              dateFormat='dd/MM/yyyy'
              timeIntervals={5}
              locale='id-ID'
              selected={moment(formFilter.tanggal_awal).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tanggal_awal: e,
                });
              }}
              placeholderText='Tanggal'
            />
          </Grid>
          <Grid item sm={6}>
            <label htmlFor='date' className='form-control-label'>
              TANGGAL AKHIR
            </label>

            <DatePicker
              id='date'
              autoComplete='off'
              className='form-control text'
              dateFormat='dd/MM/yyyy'
              timeIntervals={5}
              locale='id-ID'
              selected={moment(formFilter.tanggal_akhir).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tanggal_akhir: e,
                });
              }}
              placeholderText='Tanggal'
            />
          </Grid>

        </Grid>
        <br />
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            type={"submit"}
            size={"md"}
          />
        </Grid>
        <br />
      </form>
      <Divider />
    </>
  );
}
